<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">শিক্ষাগত যোগ্যতার তালিকা</v-col>
      <v-col cols="6" class="text-end">
        <v-btn color="secondary" size="small" class="me-3 rounded-lg" @click="openModal">
          <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
        </v-btn>
      </v-col>
      <v-col cols="12" md="12">
        <v-table class="language-table">
          <thead>
          <tr>
            <th>অর্জিত ডিগ্রি</th>
            <th>শিক্ষার স্তর</th>
            <th>শিক্ষাগত যোগ্যতা</th>
            <th>বিশ্ববিদ্যালয়</th>
            <th>অধ্যায়নের বিষয়</th>
            <th width="120">অ্যাকশন</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td colspan="6" class="text-center py-6">
              কোন তথ্য পাওয়া যায়নি
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>


    <form>
      <InsertModal ref="Modal" title="শিক্ষাগত যোগ্যতা" :width="900">
        <template #modalBody>
          <v-row>
            <v-col cols="12">
              <label class="font-weight-bold">অর্জিত ডিগ্রি *</label>
              <v-radio-group inline v-model="degreeType">
                <v-radio label="দেশ" value="local"></v-radio>
                <v-radio label="বিদেশ" value="foreign"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-divider class="mb-4"></v-divider>
          <div v-if="degreeType === 'local'">
            <v-row>
              <v-col cols="12" md="6">
                <v-select label="শিক্ষার স্তর *" variant="outlined" :items="[]"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="শিক্ষাগত যোগ্যতা *" variant="outlined" :items="[]"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="বিশ্ববিদ্যালয় *" variant="outlined" :items="[]"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="অধ্যায়নের বিষয় *" variant="outlined" :items="[]"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="ফলাফলের ধরন *" variant="outlined" :items="[]"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="উত্তীর্ণের বছর (ইংরেজি) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                    class="flex-grow-1"
                    variant="outlined"
                    rounded="lg"
                    prepend-icon=""
                    hide-details="auto"
                    density="comfortable"
                    label="মার্কশিট আপলোড"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="সর্বোচ্চ সাইজ ৪ এমবি।"
                    persistent-hint
                    prepend-inner-icon="mdi-file"
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                    class="flex-grow-1"
                    variant="outlined"
                    rounded="lg"
                    prepend-icon=""
                    hide-details="auto"
                    density="comfortable"
                    label="সার্টিফিকেট আপলোড করুন *"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="সর্বোচ্চ সাইজ ৪ এমবি।"
                    persistent-hint
                    prepend-inner-icon="mdi-file"
                ></v-file-input>

              </v-col>
              <v-col cols="12">
                <label class="font-weight-bold">ডিগ্রি চাকরিতে যোগদানের পূর্বে অর্জিত কি না?</label>
                <v-radio-group inline><v-radio label="হ্যাঁ" value="yes"></v-radio><v-radio label="না" value="no"></v-radio></v-radio-group>
              </v-col>
            </v-row>
          </div>
          <div v-else-if="degreeType === 'foreign'">
            <v-row>
              <v-col cols="12" md="6">
                <v-select label="দেশের নাম *" variant="outlined"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="বিদেশি প্রতিষ্ঠানের ঠিকানা *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="শিক্ষার স্তর *" variant="outlined"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="শিক্ষাগত যোগ্যতা *" variant="outlined"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="শিক্ষা প্রতিষ্ঠানের নাম(ইংরেজি) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="শিক্ষা প্রতিষ্ঠানের নাম(বাংলা) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label>অর্জিত ডিগ্রি ইউজিসি কর্তৃক সমতায়ন আছে কি না?</label>
                <v-radio-group inline><v-radio label="হ্যাঁ" value="yes"></v-radio><v-radio label="না" value="no"></v-radio></v-radio-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="সমতায়িত অধ্যয়নের বিষয় *" variant="outlined"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="বিদেশে অধ্যয়নের বিষয়(বাংলা) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="বিদেশে অধ্যয়নের বিষয়(ইংরেজি) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label>ফলাফল সমতায়ন করা আছে কি না?</label>
                <v-radio-group inline><v-radio label="হ্যাঁ" value="yes"></v-radio><v-radio label="না" value="no"></v-radio></v-radio-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-select label="ফলাফলের ধরন *" variant="outlined"></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="উত্তীর্ণের বছর (ইংরেজি) *" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                    class="flex-grow-1"
                    variant="outlined"
                    rounded="lg"
                    prepend-icon=""
                    hide-details="auto"
                    density="comfortable"
                    label="মার্কশিট আপলোড"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="সর্বোচ্চ সাইজ ৪ এমবি।"
                    persistent-hint
                    prepend-inner-icon="mdi-file"
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                    class="flex-grow-1"
                    variant="outlined"
                    rounded="lg"
                    prepend-icon=""
                    hide-details="auto"
                    density="comfortable"
                    label="সার্টিফিকেট আপলোড করুন *"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="সর্বোচ্চ সাইজ ৪ এমবি।"
                    persistent-hint
                    prepend-inner-icon="mdi-file"
                ></v-file-input>
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                    class="flex-grow-1"
                    variant="outlined"
                    rounded="lg"
                    prepend-icon=""
                    hide-details="auto"
                    density="comfortable"
                    label="ইউজিসি কর্তৃক অধ্যয়নের বিষয় ও ফলাফল সমতায়নের প্রমাণক *"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hint="সর্বোচ্চ সাইজ ৪ এমবি।"
                    persistent-hint
                    prepend-inner-icon="mdi-file"
                ></v-file-input>
              </v-col>
              <v-col cols="12">
                <label class="font-weight-bold">ডিগ্রি চাকরিতে যোগদানের পূর্বে অর্জিত কি না?</label>
                <v-radio-group inline><v-radio label="হ্যাঁ" value="yes"></v-radio><v-radio label="না" value="no"></v-radio></v-radio-group>
              </v-col>
            </v-row>
          </div>
        </template>
        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" size="large" class="me-3 rounded-lg" type="submit">
                <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
              </v-btn>
              <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
                <v-icon start>mdi-refresh</v-icon>রিসেট
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "EducationalQualification",
  components: {InsertModal},
  data() {
    return {
      degreeType: 'local',
      form: {

      },
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.$refs.Modal.openModal()
    },
    editItem(item) {
      console.log("Edit:", item);
    },

    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {

      };
    },
  },
};
</script>
